import { render, staticRenderFns } from "./AcceptReviewer.vue?vue&type=template&id=37fd07c2&"
import script from "./AcceptReviewer.vue?vue&type=script&lang=js&"
export * from "./AcceptReviewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports